import { all } from 'redux-saga/effects'

import { editPortfolioRootSaga } from '../state/edit-portfolio-slice'

export function* rootSaga() {
  yield all([editPortfolioRootSaga()])
}
